import { render, staticRenderFns } from "./TeachWithUs.vue?vue&type=template&id=271785fe&"
import script from "./TeachWithUs.vue?vue&type=script&lang=js&"
export * from "./TeachWithUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports